/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRequestAppointmentModal_user$ref = any;
export type PdpRequestAppointmentModalLoader_user$ref = any;
export type PdpRequestAppointmentModalLoader_user = {
    readonly " $fragmentRefs": PdpRequestAppointmentModal_user$ref;
    readonly " $refType": PdpRequestAppointmentModalLoader_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRequestAppointmentModalLoader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRequestAppointmentModal_user",
      "args": null
    }
  ]
};
(node as any).hash = 'e64700477dc2c58741a7f79a7b8446d9';
export default node;
